import {ChangeDetectorRef, Component, HostBinding, HostListener, inject, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {RouteConfigLoadEnd, RouteConfigLoadStart, Router} from "@angular/router";
import {routeAnimations} from "./shared/animations/router-animation";
import {TranslateService} from "@ngx-translate/core";
import {Observable} from "rxjs";
import {InactivityTimerService} from "./services/inactivity-timer.service";
import {NgxPermissionsService} from "ngx-permissions";
import * as AOS from 'aos';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  animations: [routeAnimations]
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'epaper';
  isLoading: boolean;
  loadingRoute: boolean;
  translate = inject(TranslateService);
  viewType?: string;
  translations: Observable<any>;
  
  // ADD THIS: Control Msaada AI visibility
  showMsaadaAI: boolean = false;

  constructor(
    private router: Router,
    private inactivityTimerService: InactivityTimerService,
    private permissionsService: NgxPermissionsService,
    private cdr: ChangeDetectorRef
  ) {
    this.translate.addLangs(['en', 'sw']);
    if (!localStorage.getItem('lang')) {
      localStorage.setItem('lang', 'sw');
      this.translate.setDefaultLang('sw');
      this.translate.use('sw');
    } else {
      this.translate.use(localStorage.getItem('lang'));
      this.translate.setDefaultLang(localStorage.getItem('lang'));
    }
    this.router.events.subscribe(() => {
      setTimeout(() => {
        AOS.refreshHard();
      }, 100);
    });
  }

  ngOnInit(): void {
    const permissions = []
    permissions.push('NO_PERMISSION');
    if (permissions?.length > 0) {
      console.log('permissions', permissions);
      this.permissionsService.loadPermissions(permissions);
    }
    this.router.events.subscribe((event) => {
      if (event instanceof RouteConfigLoadStart) {
        this.loadingRoute = true;
      } else if (event instanceof RouteConfigLoadEnd) {
        this.loadingRoute = false;
      }
    });
    AOS.init({
      duration: 600,
      easing: 'ease-in-out',
      once: true, 
    });
    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    this.inactivityTimerService.resetTimer();
  }

  onViewChange(type: string) {
    this.viewType = type;
  }

  closeView() {
    this.viewType = undefined;
  }

  // ADD THESE METHODS:
  toggleMsaadaAI() {
    this.showMsaadaAI = !this.showMsaadaAI;
  }

  closeMsaadaAI() {
    this.showMsaadaAI = false;
  }

  @HostListener('document:mousemove')
  @HostListener('document:click')
  @HostListener('document:keypress')
  refreshUserActivity(): void {
    this.inactivityTimerService.refreshUserActivity();
  }
}